(function ($, Drupal) {
  // Cart stuff
  Drupal.behaviors.initCartQty = {
    attach(context, settings) {
      $('.cart-form', context).once('initCartQty').each(() => {
        $('#coupon_redemption-ajax-wrapper label').on('click', () => {
          $('#coupon_redemption-ajax-wrapper').addClass('active');
        });

        let $gwpWrap = $("div[data-drupal-selector*='edit-gift-with-purchase']"),
          $gwpItem = $gwpWrap.find('.js-form-item');

        $gwpItem.on('click', function () {
          setTimeout(function () {
            $("input[data-drupal-selector*='edit-gift-with-purchase-add-gwp']").mousedown();
          }, 100);
          setTimeout(function () {
            location.reload();
          }, 150);
        });

      });

      if ($(window).width() < 767) {
        const continueShopping = $('.cart__continue-shopping');
        $('.cart__continue-shopping').remove();
        if (!$('.cart__continue-shopping').length) {
          continueShopping.insertAfter('.cart-js-form');
        }
      }

      $('.cart__form .delete-item span.i').on('click', function () {
        $(this).next('.delete-order-item').once().click();
      });

      if ($(window).width() < 767) {
        $('.cart__blocks .card__heading').unbind('click').bind('click', function () {
          if ($(this).hasClass('is-open')) {
            $(this).removeClass('is-open');
            $(this).next('.card__text').hide(250);
          } else {
            $(this).addClass('is-open');
          }
        });
      }

      $('.cart__actions-buttons input[id^="edit-checkout"]').on('click', function () {
        $('.cart__form input[id^="edit-checkout"]').click();
      });

      $('.cart__actions-buttons #edit-paypal').on('click', function () {
        $('.cart__form #edit-paypal').click();
      });

      $('.cart__actions-buttons #edit-alipay').on('click', function () {
        $('.cart__form #edit-alipay').click();
      });

      $('.cart__actions #amazonpaymentbutton').on('click', function () {
        $('.cart__form #amazonpaymentbutton').click();
      });


      if ($(window).width() < 767) {
        const continueShopping = $('.continue__shopping');
        const checkoutButtons = $('div[id^="edit-actions"]');
        $('.continue__shopping').remove();
        // continueShopping.insertAfter('#edit-checkout');
        checkoutButtons.append(continueShopping);
      }


      if ($('#edit-gift-with-purchase').length && !$('#edit-gift-with-purchase:empty').length && !$('.gwp__added').length && !$('.gwp__not-allowed').length) {
        let gwpAdded = 0,
          paymentWay = '';

        $(document).on('click', 'span.yes', () => {
          gwpAdded = 1;
          $(paymentWay).click();
        });

        $(document).on('click', 'span.no', function () {
          const $targetScroll = $('#edit-gift-with-purchase'),
            $targetContainer = $('html, body');
          $targetContainer.animate({ scrollTop: $targetScroll.offset().top - 200 }, 300);
        });

        $('div[id^="edit-actions"] input').on('click', (e) => {
          paymentWay = $(e.target);

          if (gwpAdded === 0) {
            e.stopImmediatePropagation();
            e.preventDefault();
            const gwpNote = '<div class="gwp__add-note clearfix"><p>' + Drupal.t("HANG ON - YOU HAVEN'T ADDED YOUR FREE GIFT YET!") + '<span>' + Drupal.t("ARE YOU SURE YOU WANT TO PROCEED?") + '</span> </p>' +
              '<div class="option-wrapper"><span class="yes">' + Drupal.t('Yes') + '</span><span class="no">' + Drupal.t('No') + '</span></div>';
            if (!$('.gwp__add-note').length) {
              $('.form-actions').prepend(gwpNote);
            }
          }
        });
      }

      if ($('.path-cart .messages').length) {
        let msg = $('.messages'),
          dest = $('.cart-form');

        if (!$('.messages').hasClass('success-text')) {
          $('.messages').remove();

          dest.prepend(msg);
          setTimeout(function () {
            $(".cart-form .messages").fadeOut(200);
          }, 3500);
        }
      }
      if ($('#coupon_redemption-ajax-wrapper').length) {
        $(".cart-form .messages").ready(function () {
          let msg = $('.cart-form .messages'),
            destiny = $('#coupon_redemption-ajax-wrapper');
          destiny.append(msg);
        });

      }


      if ($('.path-checkout .messages').length) {
        let msg = $('.messages'),
          destShipping = $('.step-order_information'),
          destPayment = $('.step-review');

        if (!$('.messages').hasClass('success-text')) {
          $('.messages').remove();

          if (destShipping.length) {
            $('form.commerce-checkout-flow').prepend(msg);
          } else {
            destPayment.prepend(msg);
          }

          setTimeout(function () {
            $(".path-checkout .messages").fadeOut(200);
          }, 3500);
        }
      }

    },
  };

  Drupal.behaviors.couponEnterKey = {
    attach: function (context, settings) {

      $('[name="coupon_redemption[code]"]').keypress(function (e) {
        var code = e.which; // recommended to use e.which, it's normalized across browsers
        if (code == 13) e.preventDefault();
        if (code == 13) {
          $('[name="apply_coupon"]').mousedown();
        }
      });
    }
  };

  Drupal.behaviors.avataxOrderSummary = {
    attach: function (context, settings) {
      if ($('.commerce-checkout-flow-multistep-default.commerce-checkout-flow').length) {
        $(document).once().ajaxComplete(function () {
          // On focus out trigger view refresh (field address_line1).
          $('.commerce-checkout-flow-multistep-default.commerce-checkout-flow').first().find('input.address-line1').focusout(function () {
            setTimeout(function () {
              $('.view-commerce-checkout-order-summary .view-footer').trigger('RefreshView');
            }, 500);
          });

          // On focus out trigger view refresh (field postal_code).
          $('.commerce-checkout-flow-multistep-default.commerce-checkout-flow').first().find('input.postal-code').focusout(function () {
            setTimeout(function () {
              $('.view-commerce-checkout-order-summary .view-footer').trigger('RefreshView');
            }, 500);
          });
        });
      }
    }
  };
}(jQuery, Drupal));
